"use client";

import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";

// Mirrors functions/src/settings.ts's DEFAULT_SETTINGS.bundleDiscountPercent -- shown before
// (or if) the real, admin-editable `settings/business` doc loads, same reasoning as
// useSiteNavigation's DEFAULT_NAVIGATION.
const DEFAULT_BUNDLE_DISCOUNT_PERCENT = 10;

/** Real bundle-discount percent for the "save X% booking 8+" badge on session cards -- pulled
 * live from the same admin-editable settings doc the booking flow itself uses, not hardcoded,
 * so the badge can never claim a discount that isn't actually configured. */
export function useBundleDiscount(): number {
  const [percent, setPercent] = useState(DEFAULT_BUNDLE_DISCOUNT_PERCENT);

  useEffect(() => {
    let cancelled = false;
    getDoc(doc(db, "settings", "business"))
      .then((snap) => {
        if (cancelled || !snap.exists()) return;
        const value = snap.data().bundleDiscountPercent;
        if (typeof value === "number") setPercent(value);
      })
      .catch(() => {
        // Default already rendered -- a Firestore hiccup just means this visit shows the
        // last-known-good (or documented default) percent instead of the very latest edit.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return percent;
}
